import { render, staticRenderFns } from "./TankUnitBadges.vue?vue&type=template&id=452deea2&scoped=true"
import script from "./TankUnitBadges.vue?vue&type=script&lang=js"
export * from "./TankUnitBadges.vue?vue&type=script&lang=js"
import style0 from "./TankUnitBadges.vue?vue&type=style&index=0&id=452deea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452deea2",
  null
  
)

export default component.exports